// =================== masterSpareListApi.js ===================
import { createEntityAdapter, createSelector } from "@reduxjs/toolkit";

import { selectMasterSpareFilter } from "../../store/master/masterSpareSlice";
import { apiSlice } from "../apiSlice";

const buildQueryString = ({ brand = [], model = [], spare = [] }) => {
  const params = [];

  if (brand.length) params.push(`brand=${brand.join(",")}`);
  if (model.length) params.push(`model=${model.join(",")}`);
  if (spare.length) params.push(`spare=${spare.join(",")}`);

  return params.length ? `?${params.join("&")}` : "";
};

const masterSpareListAdapter = createEntityAdapter({
  selectId: (masters) => masters.id,
});

const initialState = masterSpareListAdapter.getInitialState();

export const masterSpareListApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMasterSpareList: builder.query({
      query: ({ brand, model, spare }) => {
        const qs = buildQueryString({ brand, model, spare });

        return `masters/spares${qs}`; // ✔ No %2C encoding
      },

      transformResponse: (responseData) => {
        const data = responseData?.data ?? [];
        const loadedMastersList = data.map((item) => ({
          ...item,
          modifiedModel: item.model?.toUpperCase() ?? null,
          modifiedBrand: item.brand?.toUpperCase() ?? null,
          modifiedColor: item.color?.toUpperCase() ?? null,
          modifiedPartName: item.spare?.toUpperCase() ?? null,
        }));

        return masterSpareListAdapter.setAll(initialState, loadedMastersList);
      },

      providesTags: (result, error, arg) => [
        { type: "masterSpareList", id: "LIST" },
        ...(result
          ? result.ids.map((id) => ({ type: "masterSpareList", id }))
          : []),
      ],
    }),
  }),
});

export const { useGetMasterSpareListQuery } = masterSpareListApi;

// ---------------- Selectors ----------------
const selectMasterSpareListResult = createSelector(
  selectMasterSpareFilter,
  (state) => state,
  (filters, state) =>
    masterSpareListApi.endpoints.getMasterSpareList.select({
      brand: filters.brand,
      model: filters.model,
      spare: filters.spare,
    })(state)
);

const selectMasterSpareListData = createSelector(
  [selectMasterSpareListResult],
  (result) => result?.data ?? initialState
);

export const {
  selectAll: selectMasterSpareList,
  selectById: selectMasterSpareById,
  selectIds: selectMasterSpareIds,
} = masterSpareListAdapter.getSelectors((state) =>
  selectMasterSpareListData(state)
);
